import { render, staticRenderFns } from "./album-paper.vue?vue&type=template&id=71e469a9"
import script from "./album-paper.vue?vue&type=script&lang=js"
export * from "./album-paper.vue?vue&type=script&lang=js"
import style0 from "./album-paper.vue?vue&type=style&index=0&id=71e469a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports